import React, { useEffect, useMemo, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import "../../../styles/custom.css";
import { useFormik } from "formik";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net";
import * as Yup from "yup";
import { ThemeProvider, createTheme } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import api from "../../../config/URL";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";

function ReplaceClassLessonEdit() {
  const [data, setData] = useState({});
  const [studentCourseDetailsId, setStudentCourseDetailsId] = useState(null);
  const [datas, setDatas] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState({});
  const [courseData, setCourseData] = useState(null);
  const [packageData, setPackageData] = useState(null);
  const [availableDays, setAvailableDays] = useState([]);
  const [loadIndicator, setLoadIndicator] = useState(false);
  const [batchData, setBatchData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryParams = new URLSearchParams(location.search);
  const Id = queryParams.get("Id");
  const studentId = queryParams.get("studentId");
  const centerId = searchParams.get("centerId");
  const courseId = searchParams.get("courseId");
  const day = searchParams.get("day");
  const time = searchParams.get("time");
  const [startEndDate, setStartEndDate] = useState(null);

  const validationSchema = Yup.object().shape({});

  const isValidDateString = (value) => {
    if (!value) return false;
    const d = new Date(value);
    return d instanceof Date && !isNaN(d);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        enableHiding: false,
        enableSorting: false,
        size: 50,
        header: "",
        Cell: ({ row }) => (
          <div style={{ textAlign: "center", cursor: "pointer" }}>
            <input
              type="radio"
              style={{ cursor: "pointer" }}
              className="form-check-input pointer"
              name="courseSelection"
              onClick={() => handleRowSelect(row.original)}
            />
          </div>
        ),
      },
      {
        accessorFn: (row, index) => index + 1,
        header: "S.NO",
        enableSorting: true,
        enableHiding: false,
        size: 40,
        cell: ({ cell }) => (
          <span style={{ textAlign: "center" }}>{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "availableSlots",
        enableHiding: false,
        header: "Available Slots",
        size: 50,
        Cell: ({ cell }) => (
          <div className="d-flex justify-content-center">
            {cell.getValue() ? (
              <span className="badge rounded-pill text-bg-success">
                {cell.getValue()}
              </span>
            ) : (
              <span className="badge rounded-pill text-bg-danger">0</span>
            )}
          </div>
        ),
      },
      {
        accessorKey: "course",
        enableHiding: false,
        header: "Course",
      },
      {
        accessorKey: "batch",
        enableHiding: false,
        header: "Time",
        size: 50,
        Cell: ({ cell }) => {
          const [hours, minutes] = cell.getValue().split(":").map(Number);
          const ampm = hours >= 12 ? "PM" : "AM";
          const formattedTime = `${hours % 12 || 12}:${String(minutes).padStart(
            2,
            "0",
          )} ${ampm}`;
          return <span>{formattedTime}</span>;
        },
      },
      {
        accessorKey: "startDate",
        enableHiding: false,
        header: "Start Date",
        size: 50,
      },
      {
        accessorKey: "endDate",
        enableHiding: false,
        header: "End Date",
        size: 50,
      },
      {
        accessorKey: "days",
        enableHiding: false,
        header: "Days",
        size: 50,
      },
      {
        accessorKey: "createdBy",
        header: "Created By",
        Cell: ({ cell }) => cell.getValue() || "",
      },
      {
        accessorKey: "createdAt",
        header: "Created On",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10),
      },
      {
        accessorKey: "updatedAt",
        header: "Updated On",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10) || "",
      },
      {
        accessorKey: "updatedBy",
        header: "Updated By",
        Cell: ({ cell }) => cell.getValue() || "",
      },
    ],
    [],
  );

  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: "#535454 !important",
            backgroundColor: "#e6edf7 !important",
            fontWeight: "400 !important",
            fontSize: "13px !important",
            textAlign: "center !important",
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          root: {
            "&.Mui-disabled .MuiSwitch-track": {
              backgroundColor: "#f5e1d0",
              opacity: 1,
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
              color: "#eb862a",
            },
          },
          track: {
            backgroundColor: "#e0e0e0",
          },
          thumb: {
            color: "#eb862a",
          },
          switchBase: {
            "&.Mui-checked": {
              color: "#eb862a",
            },
            "&.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#eb862a",
            },
          },
        },
      },
    },
  });
  const getDayFromDate = (dateStr) => {
    if (!dateStr) return "";
    const days = [
      "SUNDAY",
      "MONDAY",
      "TUESDAY",
      "WEDNESDAY",
      "THURSDAY",
      "FRIDAY",
      "SATURDAY",
    ];
    const date = new Date(dateStr);
    return days[date.getDay()];
  };

  const formik = useFormik({
    initialValues: {
      packageId: "",
      lessonName: "",
      courseId: courseId || "",
      day: day || "",
      batchs: time || "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      console.log("Form Submitted", values);
      formik.setTouched({
        packageId: true,
        lessonName: true,
      });

      if (!formik.isValid) {
        toast.error("Please fill all the required fields");
        return;
      }

      if (!selectedRow) {
        toast.warning("Please select a course");
        return;
      }
      setLoadIndicator(true);
      const payload = {
        ...values,
        studentId: studentId,
        centerId: selectedRowData.centerId,
        centerName: selectedRowData.centerName,
        classId: selectedRowData.classId,
        className: selectedRowData.className,
        course: selectedRowData.course,
        courseId: selectedRowData.courseId,
        batchId: selectedRowData.batchId,
        batch: selectedRowData.batch,
        days: selectedRowData.days,
        classRoom: selectedRowData.classRoom,
        startDate: selectedRowData.startDate,
        lessonName: values.day,
        endDate: selectedRowData.endDate,
        studentCount: selectedRowData.studentCount,
        teacher: selectedRowData.teacher,
        userId: selectedRowData.userId,
      };

      const payloadNew = {
        userId: selectedRowData.userId,
        // days: selectedRowData.days,
        days: getDayFromDate(values.day),
        // lessonName: values.day,
        studentId: studentId,
        specificDate: values.day,
        // specificDate: values.lessonName,
        batch: selectedRowData.batch,
        classId: selectedRowData.classId,
        replacementId: Id,
      };

      console.log("Payload Data:", payload);
      try {
        let response;

        if (studentCourseDetailsId !== null) {
          response = await api.post(`/assign-replacement`, payloadNew, {
            headers: {
              "Content-Type": "application/json",
            },
          });
        } else {
          response = await api.post(`/createStudentCourseDetails`, payload, {
            headers: {
              "Content-Type": "application/json",
            },
          });
        }

        if (response.status === 200 || response.status === 201) {
          // Call updateStatus API after successful update/create
          try {
            const statusResponse = await api.put(
              `/updateStatus/${Id}?leaveStatus=APPROVED`,
              {},
              {
                headers: {
                  "Content-Type": "application/json",
                },
              },
            );

            if (statusResponse.status === 200) {
              toast.success("Status updated to APPROVED successfully.");
            } else {
              toast.error(
                statusResponse.data.message || "Failed to update status.",
              );
            }
          } catch (statusError) {
            toast.error(
              statusError.response?.data?.message ||
                "An error occurred while updating status.",
            );
          }

          toast.success(response.data.message);
          navigate("/replaceclasslesson");
          formik.resetForm();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        if (error?.response?.status === 409) {
          toast.warning(error?.response?.data?.message);
        } else if (error?.response?.status === 404) {
          toast.warning(error?.response?.data?.message);
        } else {
          toast.error(error?.response?.data?.message);
        }
      } finally {
        setLoadIndicator(false);
      }
    },
  });

  const scrollToError = (errors) => {
    const errorField = Object.keys(errors)[0];
    const errorElement = document.querySelector(`[name="${errorField}"]`);
    if (errorElement) {
      errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      errorElement.focus();
      toast.warning("Please fill all the required fields");
    }
  };

  useEffect(() => {
    if (formik.submitCount > 0 && Object.keys(formik.errors).length > 0) {
      scrollToError(formik.errors);
    }
  }, [formik.submitCount, formik.errors]);

  const fetchCourseData = async () => {
    try {
      const response = await api.get(`/getCourseNameByStudentId/${studentId}`);
      setCourseData(response.data);
    } catch (error) {
      console.error("Error fetching course data:", error);
    }
  };

  const fetchPackageData = async () => {
    if (!selectedRowData.centerId || !selectedRowData.courseId) {
      console.log(
        "Both Center ID and Course ID are required to fetch packages",
      );
      return;
    }

    try {
      const response = await api.get(
        `/courseFeeAvailablePackages?centerId=${selectedRowData.centerId}&courseId=${selectedRowData.courseId}`,
      );
      setPackageData(response.data);
      console.log("Fetched Package Data:", response.data);
    } catch (error) {
      toast.error(error.message || "Failed to fetch packages");
    }
  };

  const fetchStartandEndDate = async () => {
    // Ensure that both centerId and courseId are present in selectedRowData
    if (!selectedRowData.classId) {
      return;
    }

    try {
      const response = await api.get(
        `/getScheduledStartDates?classId=${selectedRowData.classId}`,
      );
      setStartEndDate(response.data);
      console.log("Fetched Package Data:", response.data); // For debugging
    } catch (error) {
      toast.error(error.message || "Failed to fetch packages");
    }
  };

  useEffect(() => {
    fetchPackageData();
    fetchStartandEndDate();
  }, [selectedRowData]);

  useEffect(() => {
    fetchCourseData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      // Initialize an empty params object
      let params = {};

      // Only add non-empty filter values to params
      if (formik.values.courseId) {
        params.courseId = formik.values.courseId;
      }
      if (formik.values.day) {
        params.day = formik.values.day;
      }

      if (formik.values.batchs) {
        params.batchs = formik.values.batchs;
      }

      // Make API call with centerId in path and only non-empty params
      const response = await api.get(
        `/getCourseClassListingTeachers/${centerId}`,
        {
          params: Object.keys(params).length > 0 ? params : undefined,
        },
      );
      setDatas(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [formik.values.courseId, formik.values.batchs, formik.values.day]);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await api.get(`/getAllStudentById/${studentId}`);
        setData(response.data);

        const studentCourseDetail = response.data.studentCourseDetailModels[0];
        setStudentCourseDetailsId(studentCourseDetail.id);
        console.log("studentCourseDetail:", studentCourseDetail);
        formik.setValues({
          ...formik.values,
          studentCourseDetailsId: studentCourseDetail.id,
        });

        console.log("Student Course Detail Id:", studentCourseDetail.id);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getData();
  }, [Id]);

  const handleRowSelect = (data) => {
    if (data.availableSlots === 0) {
      toast.warning("Class is Full");
      return;
    }

    setSelectedRow(data.id);
    setSelectedRowData(data);
    console.log("Selected Row Data:", data);

    if (data.startDate && data.endDate && data.days) {
      const days = calculateDays(data.startDate, data.endDate, data.days);
      setAvailableDays(days);
    } else {
      setAvailableDays([]);
    }
  };

  const calculateDays = (startDate, endDate, selectedDay) => {
    if (!startDate || !endDate || !selectedDay) {
      return [];
    }

    const start = new Date(startDate);
    const end = new Date(endDate);
    const days = [];

    const dayMapping = {
      SUNDAY: 0,
      MONDAY: 1,
      TUESDAY: 2,
      WEDNESDAY: 3,
      THURSDAY: 4,
      FRIDAY: 5,
      SATURDAY: 6,
    };

    // const targetDay = dayMapping[selectedDay.toUpperCase()];

    const safeDay =
      typeof selectedDay === "string" ? selectedDay.toUpperCase() : null;
    const targetDay = dayMapping[safeDay];

    if (targetDay === undefined) {
      return [];
    }

    for (
      let date = new Date(start);
      date <= end;
      date.setDate(date.getDate() + 1)
    ) {
      if (date.getDay() === targetDay) {
        days.push({
          value: date.toISOString().split("T")[0],
          label: date.toDateString(),
        });
      }
    }

    return days;
  };

  const fetchBatchandTeacherData = async (day) => {
    try {
      const response = await api.get(
        `getTeacherWithBatchListByDay?date=${day}`,
      );
      setBatchData(response.data.batchList);
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (formik.values.day) {
      fetchBatchandTeacherData(formik.values.day);
    }
  }, [formik.values.day]);

  const formatTo12Hour = (time) => {
    const [hours, minutes] = time.split(":");
    let period = "AM";
    let hour = parseInt(hours, 10);

    if (hour === 0) {
      hour = 12;
    } else if (hour >= 12) {
      period = "PM";
      if (hour > 12) hour -= 12;
    }

    return `${hour}:${minutes} ${period}`;
  };

  const normalizeTime = (time) => {
    if (time.includes("AM") || time.includes("PM")) {
      return time;
    }

    return formatTo12Hour(time);
  };

  const convertTo24Hour = (time) => {
    const [timePart, modifier] = time.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);

    if (modifier === "PM" && hours < 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };

  return (
    <div className="container-fluid">
      <ol
        className="breadcrumb my-3 px-2"
        style={{ listStyle: "none", padding: 0, margin: 0 }}
      >
        <li>
          <Link to="/" className="custom-breadcrumb">
            Home
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          Student Management
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          <Link to={`/replaceclasslesson`} className="custom-breadcrumb">
            Replace Class Lesson List View
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          Replace Class
        </li>
      </ol>
      <form
        onSubmit={formik.handleSubmit}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !formik.isSubmitting) {
            e.preventDefault();
          }
        }}
      >
        <div className="card">
          <div
            className="d-flex justify-content-between align-items-center p-1 mb-4 px-4"
            style={{ background: "#f5f7f9" }}
          >
            <div className="d-flex align-items-center">
              <div className="d-flex">
                <div className="dot active"></div>
              </div>
              <span className="me-2 text-muted">Replace Class</span>
            </div>
            <div className="my-2 pe-3 d-flex align-items-center">
              <Link to={`/replaceclasslesson`}>
                <button type="button" className="btn btn-sm btn-border">
                  Back
                </button>
              </Link>
              <button
                type="submit"
                className="btn btn-button btn-sm ms-3"
                onClick={formik.handleSubmit}
                disabled={loadIndicator}
              >
                {loadIndicator && (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    aria-hidden="true"
                  ></span>
                )}
                <span className="fw-medium">Arrange</span>
              </button>
            </div>
          </div>
          <div className="p-2 table-responsive">
            <table className="table table-border-solid">
              <thead>
                <tr>
                  <th scope="col" className="fw-medium">
                    S.No
                  </th>
                  <th scope="col" className="fw-medium">
                    Current Course
                  </th>
                  <th scope="col" className="fw-medium">
                    Time
                  </th>
                  <th scope="col" className="fw-medium">
                    Days
                  </th>
                  <th scope="col" className="fw-medium">
                    Package
                  </th>
                  <th scope="col" className="fw-medium">
                    Lesson Start Date
                  </th>
                  <th scope="col" className="fw-medium">
                    Lesson End Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.studentCourseDetailModels &&
                  data.studentCourseDetailModels.map((stdCourse, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{stdCourse.course || "--"}</td>
                      <td>
                        {stdCourse.batch
                          ? (() => {
                              const [hours, minutes] = stdCourse.batch
                                .split(":")
                                .map(Number);
                              const ampm = hours >= 12 ? "PM" : "AM";
                              const formattedTime = `${
                                hours % 12 || 12
                              }:${String(minutes).padStart(2, "0")} ${ampm}`;
                              return formattedTime;
                            })()
                          : "--"}
                      </td>
                      <td>{stdCourse.days || "--"}</td>
                      <td>{stdCourse.packageName || "--"}</td>
                      <td>{stdCourse.lessonName || "--"}</td>
                      <td>{stdCourse.endDate || "--"}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="border-0 my-2 px-2">
            <div className="row mt-2">
              <div className="col-md-4">
                <select
                  {...formik.getFieldProps("courseId")}
                  className={`form-select ${
                    formik.touched.courseId && formik.errors.courseId
                      ? "is-invalid"
                      : ""
                  }`}
                  id="courseId"
                  name="courseId"
                >
                  <option value="" disabled>
                    Select Course
                  </option>
                  {courseData &&
                    courseData.map((course) => (
                      <option key={course.id} value={course.id}>
                        {course.courseNames}
                      </option>
                    ))}
                </select>
              </div>
              {/* <div className="col-md-4">
                <select
                  {...formik.getFieldProps("days")}
                  className={`form-select ${
                    formik.touched.days && formik.errors.days
                      ? "is-invalid"
                      : ""
                  }`}
                  id="days"
                  name="days"
                  onChange={handleDayChange}
                >
                  <option value="" disabled>
                    Select Day
                  </option>
                  <option value="MONDAY">MONDAY</option>
                  <option value="TUESDAY">TUESDAY</option>
                  <option value="WEDNESDAY">WEDNESDAY</option>
                  <option value="THURSDAY">THURSDAY</option>
                  <option value="FRIDAY">FRIDAY</option>
                  <option value="SATURDAY">SATURDAY</option>
                  <option value="SUNDAY">SUNDAY</option>
                </select>
              </div> */}
              <div className="col-md-4">
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  className={`form-control w-100 ${
                    formik.touched.day && formik.errors.day ? "is-invalid" : ""
                  }`}
                  placeholderText="Select Date"
                  selected={
                    isValidDateString(formik.values.day)
                      ? new Date(formik.values.day)
                      : null
                  }
                  onChange={(date) => {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");

                    const formattedDate = `${year}-${month}-${day}`;

                    formik.setFieldValue("day", formattedDate);
                  }}
                  showMonthDropdown
                  showYearDropdown
                  popperClassName="student-datepicker-popper"
                />

                {formik.touched.days && formik.errors.days && (
                  <div className="invalid-feedback">{formik.errors.days}</div>
                )}
              </div>
              <div className="col-md-4 d-flex">
                <select
                  {...formik.getFieldProps("batchs")}
                  className="form-select"
                  id="batchs"
                  name="batchs"
                >
                  <option value="">Select Time</option>
                  {batchData &&
                    batchData.map((time) => {
                      const displayTime = normalizeTime(time);
                      const valueTime =
                        time.includes("AM") || time.includes("PM")
                          ? convertTo24Hour(time)
                          : time;

                      return (
                        <option key={time} value={valueTime}>
                          {displayTime}
                        </option>
                      );
                    })}
                </select>
                <button
                  type="button"
                  className="btn btn-sm border-secondary ms-3 my-1"
                  style={{ width: "100px" }}
                  onClick={() => {
                    formik.resetForm({
                      values: {
                        lessonName: "",
                        packageId: "",
                        courseId: "",
                        days: "",
                        batchs: "",
                      },
                    });
                    setSelectedRow(null);
                    setSelectedRowData({});
                    setAvailableDays([]);
                    getData();
                  }}
                >
                  Clear
                </button>
              </div>
            </div>
            <div className="container my-4">
              {loading ? (
                <div className="loader-container">
                  <div className="loading">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              ) : (
                <>
                  <ThemeProvider theme={theme}>
                    <MaterialReactTable
                      columns={columns}
                      data={datas}
                      enableColumnActions={false}
                      enableColumnFilters={false}
                      enableDensityToggle={false}
                      enableFullScreenToggle={false}
                      initialState={{
                        columnVisibility: {
                          createdBy: false,
                          createdAt: false,
                          updatedBy: false,
                          updatedAt: false,
                        },
                      }}
                    />
                  </ThemeProvider>
                  {!selectedRow && (
                    <div className="text-danger text-center fs-6 mt-2">
                      * Please select a row.
                    </div>
                  )}
                </>
              )}
            </div>
            {/* <div className="row mt-2">
              {availableDays.length > 0 && (
                <div className="col-md-4">
                  <select
                    {...formik.getFieldProps("lessonName")}
                    className={`form-select  ${
                      formik.touched.lessonName && formik.errors.lessonName
                        ? "is-invalid"
                        : ""
                    }`}
                    id="lessonName"
                    name="lessonName"
                  >
                    <option value="" disabled selected>
                      Select Lesson Name
                    </option>
                    {startEndDate &&
                      startEndDate.map((seDate) => (
                        <option key={seDate.date} value={seDate.date}>
                          {seDate.showDate}
                        </option>
                      ))}
                  </select>
                  {formik.touched.lessonName && formik.errors.lessonName && (
                    <div className="invalid-feedback">
                      {formik.errors.lessonName}
                    </div>
                  )}
                </div>
              )}
            </div> */}
          </div>
        </div>
      </form>
    </div>
  );
}

export default ReplaceClassLessonEdit;
